// extracted by mini-css-extract-plugin
export default {"row":"fCpb6xc5qUyOWUlQCKtk","bio":"zrD_jnh3tVbLlscftS2E"};